import { __makeTemplateObject } from "tslib";
import { color, layout, space } from 'styled-system';
import styled from '@marvelapp/styled';
import { fill, hoverFill } from '../customProperties';
export var Svg = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:hover {\n    ", ";\n  }\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:hover {\n    ", ";\n  }\n"])), color, layout, space, fill, hoverFill);
var templateObject_1;
